exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@font-face{font-family:iconfont;src:url(\"//at.alicdn.com/t/c/font_3898067_spn7c6nuht.eot?t=1676455933675\");src:url(\"//at.alicdn.com/t/c/font_3898067_spn7c6nuht.eot?t=1676455933675#iefix\") format(\"embedded-opentype\"),url(\"//at.alicdn.com/t/c/font_3898067_spn7c6nuht.woff2?t=1676455933675\") format(\"woff2\"),url(\"//at.alicdn.com/t/c/font_3898067_spn7c6nuht.woff?t=1676455933675\") format(\"woff\"),url(\"//at.alicdn.com/t/c/font_3898067_spn7c6nuht.ttf?t=1676455933675\") format(\"truetype\"),url(\"//at.alicdn.com/t/c/font_3898067_spn7c6nuht.svg?t=1676455933675#iconfont\") format(\"svg\")}.iconfont{font-family:iconfont!important;font-size:16px;font-style:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/styles/iconfont.css
// module id = 1111
// module chunks = 45